/**
 * Message snippet localization keys for AI responses
 */

import type { MessageSubType } from '../data-layer/types';

export const MESSAGE_SNIPPET_KEYS: Record<MessageSubType, string> = {
  createAccount: 'INTEGRATIONS.COPILOT.CREATEACCOUNT',
  analyzing: 'INTEGRATIONS.COPILOT.ANALYZING_FILE',
  fileExtraction: 'INTEGRATIONS.COPILOT.FILE_EXTRACTION',
  movingNext: 'INTEGRATIONS.COPILOT.MOVING_NEXT',
  generalToConnection: 'INTEGRATIONS.COPILOT.CONNECTION_STEP',
  success: 'INTEGRATIONS.COPILOT.SUCCESS',
  start: 'INTEGRATIONS.COPILOT.GETTING_STARTED',
  createAccountHelperText: 'INTEGRATION_ASSIST_ON_CREATE_ACCOUNT',
  basic_config: 'INTEGRATIONS.COPILOT.BASIC_CONFIG',
  connection_config: 'INTEGRATIONS.COPILOT.CONNECTION_CONFIG',
  create_account_form: 'INTEGRATIONS.COPILOT.CREATE_ACCOUNT_FORM',
  update_account_form: 'INTEGRATIONS.COPILOT.UPDATE_ACCOUNT_FORM',
  enable_account_form: 'INTEGRATIONS.COPILOT.ENABLE_ACCOUNT_FORM',
  disable_account_form: 'INTEGRATIONS.COPILOT.DISABLE_ACCOUNT_FORM',
  remove_account_form: 'INTEGRATIONS.COPILOT.REMOVE_ACCOUNT_FORM',
  text_input: 'INTEGRATIONS.COPILOT.TEXT_INPUT',
  file_upload: 'INTEGRATIONS.COPILOT.FILE_UPLOAD',
  user_choice: 'INTEGRATIONS.COPILOT.USER_CHOICE',
  file_display: 'INTEGRATIONS.COPILOT.FILE_DISPLAY',
  connectionStep: 'INTEGRATIONS.COPILOT.CONNECTION_STEP',
  connectionStepAssistInfo: 'INTEGRATIONS.COPILOT.CONNECTION_STEP_ASSIST_INFO',
  selectOneOfOptions: 'INTEGRATIONS.COPILOT.SELECT_ONE_OF_OPTIONS',
  userResponseYes: 'INTEGRATIONS.COPILOT.USER_RESPONSE_YES',
  userResponseNo: 'INTEGRATIONS.COPILOT.USER_RESPONSE_NO',
  instruction_prompt: 'INTEGRATIONS.COPILOT.INSTRUCTION_PROMPT',
  connectionSuccessMovingNext:
    'INTEGRATIONS.COPILOT.CONNECTION_SUCCESS_MOVING_NEXT',
  createAccountNextStep: 'INTEGRATIONS.COPILOT.CREATE_ACCOUNT_NEXT_STEP',
  createAccountAssist: 'INTEGRATIONS.COPILOT.CREATE_ACCOUNT_ASSIST',
  additionalInformation: 'INTEGRATIONS.COPILOT.ADDITIONAL_INFORMATION',
  confirmOnboard: 'INTEGRATIONS.COPILOT.CONFIRM_ONBOARD',
  proceedToUpdateAccount: 'INTEGRATIONS.COPILOT.PROCEED_TO_UPDATE_ACCOUNT',
  updateAccountStepAssistInfo:
    'INTEGRATIONS.COPILOT.UPDATE_ACCOUNT_STEP_ASSIST_INFO',
  updateAccountConfirmationInfo:
    'INTEGRATIONS.COPILOT.UPDATE_ACCOUNT_CONFIRMATION_INFO',
  allAccountGenericConfirmation:
    'INTEGRATIONS.COPILOT.UPDATE_ACCOUNT_CONFIRMATION_INFO',
  enableAccountStepAssistInfo:
    'INTEGRATIONS.COPILOT.ENABLE_ACCOUNT_STEP_ASSIST_INFO',
  disableAccountStepAssistInfo:
    'INTEGRATIONS.COPILOT.DISABLE_ACCOUNT_STEP_ASSIST_INFO',
  removeAccountStepAssistInfo:
    'INTEGRATIONS.COPILOT.REMOVE_ACCOUNT_STEP_ASSIST_INFO',
  proceedToRemoveAccount: 'INTEGRATIONS.COPILOT.PROCEED_TO_REMOVE_ACCOUNT',
  proceedToEnableAccount: 'INTEGRATIONS.COPILOT.PROCEED_TO_ENABLE_ACCOUNT',
  proceedToDisableAccount: 'INTEGRATIONS.COPILOT.PROCEED_TO_DISABLE_ACCOUNT',
  movingToAccessAccount: 'INTEGRATIONS.COPILOT.ACCESS_ACCOUNT',
  accessAccountMessage: 'INTEGRATIONS.COPILOT.ADD_ACCESS',
  accessAttributeMapping: 'INTERGRATION.COPILOT.MOVING_TO_ATTRIBUTE_MAPPING',
  attributeMappingApplicationFields:
    'INTERGRATION.COPILOT.ATTRIBUTE_MAPPING_APPLICATION_FIELDS',
  attributeMappingStart: 'INTEGRATIONS.COPILOT.ATTRIBUTE_MAPPING_START',
  attributeMappingNext: 'INTEGRATIONS.COPILOT.ATTRIBUTE_MAPPING_NEXT',
  add_access_form: '',
  attributeMappingAdditionalInfo:
    'INTEGRATIONS.COPILOT.ATTRIBUTE_MAPPING_ADDITIONAL_INFORMATION',
  removeAccessNextStep: 'INTEGRATIONS.COPILOT.REMOVE_ACCESS_NEXT_STEP',
  provideAdditionalInfo: 'INTEGRATIONS.COPILOT.PROVIDEINFO',
  basicUpdateSuccess: 'INTEGRATIONS.COPILOT.BASIC.UPDATE.SUCCESS',
  createAccountUpdateSuccess:
    'INTEGRATIONS.COPILOT.CREATE_ACCOUNT.UPDATE.SUCCESS',
  updateAccountUpdateSuccess:
    'INTEGRATIONS.COPILOT.UPDATE_ACCOUNT.UPDATE.SUCCESS',
  enableAccountUpdateSuccess:
    'INTEGRATIONS.COPILOT.ENABLE_ACCOUNT.UPDATE.SUCCESS',
  disableAccountUpdateSuccess:
    'INTEGRATIONS.COPILOT.DISABLE_ACCOUNT.UPDATE.SUCCESS',
  removeAccountUpdateSuccess:
    'INTEGRATIONS.COPILOT.REMOVE_ACCOUNT.UPDATE.SUCCESS',
  addAccessUpdateSuccess: 'INTEGRATIONS.COPILOT.ADD_ACCESS.UPDATE.SUCCESS',
  removeAccessUpdateSuccess:
    'INTEGRATIONS.COPILOT.REMOVE_ACCESS.UPDATE.SUCCESS',
  movingToNextStep: 'INTEGRATIONS.COPILOT.MOVING_TO_NEXT_STEP',
  movingToNextAccStep: 'INTEGRATIONS.COPILOT.MOVING_TO_NEXT_ACC_STEP',
  movingToNextStepWithSkip:
    'INTEGRATIONS.COPILOT.MOVING_TO_NEXT_STEP_WITH_SKIP',
  skipTransition: 'INTEGRATIONS.COPILOT.SKIP_TRANSITION',
  enableAccountGenericConfirmation:
    'INTEGRATIONS.COPILOT.ENABLE_ACCOUNT_GENERIC_CONFIRMATION',
  disableAccountGenericConfirmation:
    'INTEGRATIONS.COPILOT.DISABLE_ACCOUNT_GENERIC_CONFIRMATION',
  removeAccountGenericConfirmation:
    'INTEGRATIONS.COPILOT.REMOVE_ACCOUNT_GENERIC_CONFIRMATION',
  updateAccount: '',
  enableAccount: '',
  disableAccount: '',
  removeAccount: '',
  removeAccessMapping: '',
  remove_access_form: '',
  removeAccess: '',
  removeAccessMappingInfo: 'INTEGRATIONS.COPILOT.REMOVE_ACCESS_MAPPING_INFO',
  finalRecommendations: 'INTEGRATIONS.COPILOT.FINAL_RECOMMENDATIONS',
  finalConfirmation: 'INTEGRATIONS.COPILOT.FINAL_CONFIRMATION',
  finalConfirmationRedirection: 'I’ll set this up later',
  error: 'ERROR_MESSAGE',
  addAccessEditPhase: 'INTEGRATIONS.COPILOT.ADD_ACCESS_EDIT_PHASE',
  allEntitlementDone: 'INTEGRATIONS.COPILOT.ADD_ACCESS_EDIT_PHASE.ALL_DONE',
  promptInstructions: 'INTEGRATIONS.COPILOT.PROMPT_INSTRUCTIONS',
  stepHelperPrompt: 'INTEGRATIONS.COPILOT.STEP_HELPER_PROMPT',
  threeButtonsHelperText: 'INTEGRATIONS.COPILOT.THREE_BUTTONS_HELPER_TEXT',
  removeAccessEditInfo: 'INTEGRATIONS.COPILOT.REMOVE_ACCESS_EDIT_INFO',
  addAccessInfoEditMode: 'INTEGRATIONS.COPILOT.ADD_ACCESS_INFO_EDIT_MODE',
  removeAccessSkipped: 'INTEGRATIONS.COPILOT.REMOVE_ACCESS_SKIPPED',
};

export default MESSAGE_SNIPPET_KEYS;
